import { Message } from 'element-ui';
class FileDownloader {
    constructor({ url, fileName, chunkSize = 1 * 1000 * 1000, cb, timeCount }) {
        this.timeCount = timeCount;
        this.url = url;
        this.fileName = fileName;
        this.chunkSize = chunkSize;
        this.fileSize = 0;
        this.totalChunks = 0;
        this.currentChunk = 0;
        this.downloadedSize = 0;
        this.chunks = [];
        this.abortController = new AbortController();
        this.paused = false;
        this.cb = cb

        // 尝试从 localStorage 加载状态
        const savedState = this.loadState();
        if (savedState) {
            this.fileName = savedState.fileName;
            this.fileSize = savedState.fileSize;
            this.currentChunk = savedState.currentChunk + 1;
            this.downloadedSize = savedState.downloadedSize;
            this.totalChunks = savedState.totalChunks;

            this.chunks = savedState.chunks.map((_, index) => savedState.chunks[index] ? new Blob([new ArrayBuffer(savedState.chunks[index].size)], { type: _.type }) : null);
            console.log(this.chunks, "totalChunks")
        } else {
            this.currentChunk = 0;
            this.downloadedSize = 0;
        }
    }


    async getFileSize() {
        try {
            const response = await fetch(this.url, { signal: this.abortController.signal });
            // 检查响应状态码是否为200
            if (response.status === 500) {
                // 尝试解析响应为JSON
                const data = await response.text()
                console.log(data)
                // 检查code字段是否为0
                // if (data.code === 0) {
                Message.error(data)
                this.cancelDownload()
                return;
                // }
            }
            console.log(JSON.stringify(response))
            const contentLength = response.headers.get("content-length");
            // const fileName = response.headers.get("content-disposition").split("filename=")[1];
            let fileName = response.headers.get("content-disposition");
            let hz = response.headers.get("content-type");

            let fileExtension = '';
            if (hz) {
                if (hz.includes('application/zip')) {
                    fileExtension = '.zip';
                } else if (hz.includes('application/pdf')) {
                    fileExtension = '.pdf';
                } else if (hz.includes('image/jpeg')) {
                    fileExtension = '.jpeg';
                } else if (hz.includes('image/png')) {
                    fileExtension = '.png';
                } else if (hz.includes('text/plain')) {
                    fileExtension = '.txt';
                } else if (hz.includes('application/msword')) {
                    fileExtension = '.doc';
                } else if (hz.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
                    fileExtension = '.docx';
                }
                // 可以继续添加其他类型的映射
            }
            if (fileName) {
                // 查找 filename* 字段
                const filenameStar = fileName.match(/filename\*=utf-8''([^;]*)/);
                console.log(filenameStar)
                if (filenameStar) {
                    this.fileName = decodeURIComponent(filenameStar[1]);
                } else {
                    // 如果 filename* 字段不存在，则解析 filename 字段
                    const filename = fileName.match(/filename="([^"]*)"/) || fileName.match(/filename=([^;]*)/);
                    if (filename) {
                        this.fileName = decodeURIComponent(filename[1]);
                    } else {
                        this.fileName = "未命名文件" + fileExtension; // 默认文件名
                    }
                }
            } else {
                this.fileName = "未命名文件" + fileExtension; // 默认文件名
            }
            console.log(this.fileName)
            // this.fileName = fileName;
            // response.headers.forEach((value, name) => {
            //     console.log(`${name}: ${value}打印响应头`); // 打印响应头
            // });
            this.fileSize = parseInt(contentLength, 10);
            this.totalChunks = Math.ceil(this.fileSize / this.chunkSize);
            this.cb && this.cb({
                downState: 0,
                downTime: this.timeCount,
                fileName: this.fileName,
                fileSize: this.fileSize,
                pass: false,
                add: true,
            })
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log(`下载文件 ${this.fileName} 被取消`);
            } else {
                console.error(`获取文件大小时出错: ${error.message}`);
            }
        }

    }


    async downloadChunk(chunkIndex) {
        const start = chunkIndex * this.chunkSize;
        const end = Math.min(this.fileSize, (chunkIndex + 1) * this.chunkSize);
        console.log(start, end, "start, end")
        try {
            let response
            if (this.fileSize > this.chunkSize) {
                var params = `&range=${start}-${end}`
                response = await fetch(this.url + params, {
                    // headers: { Range: `bytes=${start}-${end}` },
                    signal: this.abortController.signal
                });
            } else {
                response = await fetch(this.url, {
                    // headers: { Range: `bytes=${start}-${end}` },
                    signal: this.abortController.signal
                });
                this.cb && this.cb({
                    downState: 1,
                    downTime: this.timeCount,
                    fileName: this.fileName,
                    fileSize: this.fileSize,
                    pass: false,
                    // add: chunkIndex == 0 ? true : false,
                })
            }

            const blob = await response.blob();
            console.log(blob)
            this.chunks.push(blob);
            this.downloadedSize += blob.size;
            console.log(this.currentChunk, this.totalChunks, this.downloadedSize, this.fileSize)
            this.saveState(); // 保存当前下载状态
            if (!this.paused && this.currentChunk < this.totalChunks - 1) {//this.currentChunk < this.totalChunks - 1
                this.currentChunk++;
                // console.log(this.currentChunk, this.totalChunks, this.currentChunk / this.totalChunks)
                this.cb && this.cb({
                    downState: this.currentChunk / this.totalChunks,
                    downTime: this.timeCount,
                    fileName: this.fileName,
                    fileSize: this.fileSize,
                    pass: false,
                    // add: chunkIndex == 0 ? true : false,
                })
                this.downloadChunk(this.currentChunk);
            } else if (this.currentChunk === this.totalChunks - 1) {//this.currentChunk === this.totalChunks - 1
                setTimeout(() => {
                    this.mergeChunks();
                }, 1000);
            } else if (!this.totalChunks) {
                this.mergeChunks();
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log(`下载文件 ${this.fileName} 被取消`);
            } else {
                console.error(`获取文件大小时出错: ${error.message}`);
            }
        }
    }


    async startDownload() {
        console.log(this.chunks.length)
        if (this.chunks.length === 0) {
            await this.getFileSize();
        }
        this.downloadChunk(this.currentChunk);
    }


    pauseDownload() {
        this.paused = true;
        this.cb && this.cb({
            downState: this.currentChunk / this.totalChunks,
            downTime: this.timeCount,
            fileName: this.fileName,
            fileSize: this.fileSize,
            pass: true
        })
    }


    resumeDownload() {
        this.paused = false;
        this.cb && this.cb({
            downState: this.currentChunk / this.totalChunks,
            downTime: this.timeCount,
            fileName: this.fileName,
            fileSize: this.fileSize,
            pass: false
        })
        this.downloadChunk(this.currentChunk);
    }


    cancelDownload() {
        this.cb && this.cb({
            downState: 1,
            downTime: this.timeCount,
            fileName: this.fileName,
            fileSize: this.fileSize,
            pass: false
        })
        this.abortController.abort();
        this.reset();
        // localStorage.removeItem('fileDownloaderState'); // 清除保存的状态
    }


    async mergeChunks() {
        const contentType = this.chunks[0].type || "application/octet-stream";
        const blob = new Blob(this.chunks, { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.fileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            this.cb && this.cb({
                downState: 1,
                downTime: this.timeCount,
                fileName: this.fileName,
                fileSize: this.fileSize,
                pass: false
            })
            this.reset();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }


    reset() {
        this.chunks = [];
        this.fileName = '';
        this.fileSize = 0;
        this.totalChunks = 0;
        this.currentChunk = 0;
        this.downloadedSize = 0;
        // const prefix = 'fileDownloaderState';
        // const keys = [];
        // for (let i = 0; i < localStorage.length; i++) {
        //     const key = localStorage.key(i);
        //     if (key.startsWith(prefix)) {
        //         keys.push(key);
        //     }
        // }
        // console.log(keys)
        // keys.forEach(key => {
        //     localStorage.removeItem(key);
        // });
        localStorage.removeItem('fileDownloaderState' + this.timeCount); // 清除保存的状态
    }


    // 保存下载状态至 localStorage 或其他持久化存储
    saveState() {
        console.log(this.chunks, "this.chunks")
        const state = {
            currentChunk: this.currentChunk,
            downloadedSize: this.downloadedSize,
            totalChunks: this.totalChunks,
            url: this.url,
            fileName: this.fileName,
            fileSize: this.fileSize,
            timeCount: this.timeCount,
            chunks: this.chunks.map(chunk => chunk ? { type: chunk.type, size: chunk.size } : null) // 仅保存每个 blob 的大小以简化存储
        };
        localStorage.setItem('fileDownloaderState' + this.timeCount, JSON.stringify(state));
    }

    // 从 localStorage 或其他持久化存储加载下载状态
    loadState() {
        const savedState = localStorage.getItem('fileDownloaderState' + this.timeCount);
        if (savedState) {
            const state = JSON.parse(savedState);
            return state;
        }
        return null;
    }
}
export default FileDownloader;
